class Bundle {
  language = null;
  localizer = null; // instance of Localizer

  // preload an asset in a particular format to ensure it's available
  async preload(name, format = null) {}

  // get a resource in the specific format
  get(name, format = null) {}

  // each call to get() should be followed by a call to release()
  release(name, format = null) {}

  // invoked at the very end of a psych test to destroy all assets
  // regardless of resource gc count
  destroy() {}
}

class BundleContext {
  constructor(registry, id) {
    this.registry = registry;
    this.id = id;
  }

  get current() {
    const bundle = this.registry.contexts[this.id];
    if (!bundle) {
      throw new Error(`no bundle is bound to context="${this.id}"`);
    }
    return bundle;
  }
}

class BundleRegistry {
  lastContextId = 0;
  contexts = {};

  createContext(name) {
    const id = `${name}-${++this.lastContextId}`;
    return new BundleContext(this, id);
  }

  bindContext(ctx, bundle) {
    if (!this.contexts[ctx.id]) {
      this.contexts[ctx.id] = bundle;
    }
    return ctx;
  }

  unbindContext(ctx, bundle) {
    if (this.contexts[ctx.id] === bundle) {
      delete this.contexts[ctx.id];
    }
    return ctx;
  }

  isContextBound(ctx, bundle = null) {
    const boundBundle = this.contexts[ctx.id];
    if (!boundBundle) return false;
    if (bundle && bundle !== boundBundle) return false;
    return true;
  }
}

const defaultRegistry = (global.ptBundleRegistry =
  global.ptBundleRegistry || new BundleRegistry());
const createBundleContext = ::defaultRegistry.createContext;
const bindBundleContext = ::defaultRegistry.bindContext;
const unbindBundleContext = ::defaultRegistry.unbindContext;
const isBundleContextBound = ::defaultRegistry.isContextBound;

export {
  Bundle,
  BundleRegistry,
  createBundleContext,
  bindBundleContext,
  unbindBundleContext,
  isBundleContextBound,
};
